angular
    .module('util.MapModule')
    .directive('trsBaiduMap', ['trsBaiduMapService', '$state', 'modalDialog',
        function (trsBaiduMapService, $state, modalDialog) {
            return {
                restrict: 'E',
                scope: {
                    defaultPlace: '=', // 默认地点
                    zoomLevel: '@', // 指定地图缩放级别
                    isLocation: '@', // 初始化是否默认定位到当前位置（根据ip，位置有一定程度偏差）
                    confirm: '&', // 点击确认要执行的方法
                    cancel: '&', // 点击取消要执行的方法
                    mediaFlag: '@', // 渠道标识, 默认为 'weibo'，可选其它： 'douyin' 
                },
                replace: true,
                templateUrl: './components/util/trsMap/template/trsBaiduMap_tpl.html',
                link: function (scope, element, attrs, ctrl) {
                    require(['async!BMap'], function () {
                        initStatus();
                        dealDifferentMedia();

                        /**
                         * [initStatus 初始化页面数据]
                         *
                         * @return  {[type]}  [return description]
                         */
                        function initStatus() {
                            if (scope.mediaFlag && scope.mediaFlag === 'douyin') {
                                scope.windowTitle = '抖音定位';
                            } else {
                                scope.windowTitle = '微博定位';
                            }
                            scope.data = {
                                params: {
                                    serviceid: 'wcm61_scmmicrocontent',
                                    methodname: 'queryNearPlacePois',
                                    AccountId: $state.params.wbchannelid,
                                    jd: '',
                                    wd: '',
                                    range: 1000,
                                    offset: 0,
                                    sort: 1,
                                    count: 20,
                                },
                                sinaAddressList: [],
                            };
                            scope.status = {
                                isShowSinaAddressList: true,
                                curSelectIndex: '',
                                sinaAddressListPosition: 'right',
                                isShowSearch: false,
                            };
                        }

                        /**
                         * [dealDifferentMedia 处理不同渠道的初始化数据]
                         *
                         * @return  {[type]}  [return description]
                         */
                        function dealDifferentMedia() {
                            if (scope.mediaFlag && scope.mediaFlag === 'douyin') {
                                scope.data.params = {
                                    serviceid: 'mlf_douyin',
                                    methodname: 'queryNearPlacePois',
                                    AccountId: $state.params.accountid,
                                    keyword: '',
                                    city: '',
                                };
                                scope.status.isShowSearch = true;
                            }
                        }

                        // 初始化
                        let map = trsBaiduMapService.createMap('baidu_map');
                        let defaultPlace = scope.defaultPlace.placeName || '新疆日报社';
                        let defaultZoomLevel = scope.zoomLevel || 15;
                        if (scope.defaultPlace.placeName !== '') {
                            scope.isLocation = false;
                            getPoiByAddressName(scope.defaultPlace.placeName, function (poi) {
                                if (!poi) {
                                    scope.data.sinaAddressList = [];
                                    return;
                                }
                                let point = poi.point;
                                map.centerAndZoom(point, defaultZoomLevel);
                                trsBaiduMapService.setMarker(map, point);
                                if (scope.mediaFlag && scope.mediaFlag === 'douyin') {
                                    if (scope.defaultPlace.city !== '' && scope.defaultPlace.title !== '') {
                                        loadGaodeAddress(scope.defaultPlace.city, scope.defaultPlace.title, true);
                                    } else {
                                        let city = poi.city;
                                        let title = poi.title;
                                        loadGaodeAddress(city, title, true);
                                    }
                                } else {
                                    loadSinaAddress(point, true);
                                }
                            });
                        } else {
                            map.centerAndZoom(defaultPlace);
                        }

                        // 监听地图点击事件，当用户点击时，获取并定位到点击位置
                        map.addEventListener('click', function (e) {
                            scope.hideSinaList();
                            let point = trsBaiduMapService.createPoint(e.point);
                            if (scope.mediaFlag && scope.mediaFlag === 'douyin') {
                                let gc = trsBaiduMapService.createGeoCoder();
                                gc.getLocation(point, function (rs) {
                                    let keyword;
                                    if (rs.surroundingPois.length) {
                                        keyword = rs.surroundingPois[0].title;
                                    } else {
                                        keyword = rs.address;
                                    }
                                    loadGaodeAddress(rs.addressComponents.city, keyword);
                                });
                            } else {
                                let middleWidth = parseInt(element[0].offsetWidth / 2);
                                scope.status.sinaAddressListPosition = e.offsetX < middleWidth ? 'right' : 'right';
                                loadSinaAddress(point);
                            }
                            map.clearOverlays();
                            var marker = new BMap.Marker(point); // 创建标注    
                            map.addOverlay(marker);
                        });

                        // 初始化自动完成对象
                        let autoComplete = trsBaiduMapService.createComplete({
                            input: 'suggestionInp',
                            location: map,
                        });

                        // 定位到当前位置
                        if (scope.isLocation) {
                            trsBaiduMapService.location(function (result) {
                                map.clearOverlays();
                                if (scope.mediaFlag && scope.mediaFlag === 'douyin') {
                                    defaultZoomLevel = 12;
                                }
                                map.centerAndZoom(result.center, defaultZoomLevel);
                                trsBaiduMapService.setMarker(map, result.center);
                                if (scope.mediaFlag && scope.mediaFlag === 'douyin') {
                                    loadGaodeAddress(result.name, result.name);
                                } else {
                                    loadSinaAddress(result.center);
                                }
                            });
                        }

                        // 监听自动完成
                        autoComplete.addEventListener('onconfirm', function (e) {
                            const myValue = trsBaiduMapService.getCompleteResult(e);
                            scope.address = myValue;
                            let isError = false;
                            let timer = setTimeout(() => {
                                isError = true;
                                timer = null;
                            }, 20000);
                            // 清除地图上所有覆盖物
                            map.clearOverlays();
                            // 智能搜索
                            let local = new BMap.LocalSearch(map, {
                                onSearchComplete: function () {
                                    if (isError) {
                                        return;
                                    }
                                    scope.status.isShowSearch = false;
                                    timer && clearTimeout(timer);
                                    // 获取第一个智能搜索的结果
                                    if (!local.getResults().getPoi(0)) {
                                        getPoiByAddressName(local.getResults().province + local.getResults().city, function (poi) {
                                            if (!poi) {
                                                scope.data.sinaAddressList = [];
                                                return;
                                            }
                                            const pp = poi.point;
                                            const keyword = poi.title;
                                            const city = poi.city || poi.title;
                                            map.clearOverlays();
                                            map.centerAndZoom(new BMap.Point(pp.lng, pp.lat), 16);
                                            const mk = new BMap.Marker(pp);
                                            map.addOverlay(mk);
                                            map.panTo(pp);
                                            if (scope.mediaFlag && scope.mediaFlag === 'douyin') {
                                                loadGaodeAddress(city, keyword);
                                            } else {
                                                loadSinaAddress(pp);
                                            }
                                        });
                                    } else {
                                        const pp = local.getResults().getPoi(0).point;
                                        const keyword = local.getResults().keyword;
                                        const city = local.getResults().getPoi(0).city || local.getResults().city;
                                        map.clearOverlays();
                                        map.centerAndZoom(new BMap.Point(pp.lng, pp.lat), 16);
                                        const mk = new BMap.Marker(pp);
                                        map.addOverlay(mk);
                                        map.panTo(pp);
                                        if (scope.mediaFlag && scope.mediaFlag === 'douyin') {
                                            loadGaodeAddress(city, keyword);
                                        } else {
                                            loadSinaAddress(pp);
                                        }
                                    }
                                },
                                pageCapacity: 5,
                            });
                            local.search(myValue);
                        });

                        /**
                         * [getPoiByAddressName 根据地点名词获取POI]
                         *
                         * @param   {[type]}  addressName  [addressName description]
                         * @param   {[type]}  success      [success description]
                         *
                         * @return  {[type]}               [return description]
                         */
                        function getPoiByAddressName(addressName, success) {
                            let isError = false;
                            let timer = setTimeout(() => {
                                isError = true;
                                timer = null;
                            }, 20000);
                            let local = new BMap.LocalSearch(map, {
                                onSearchComplete: function () {
                                    if (isError) {
                                        return;
                                    }
                                    scope.status.isShowSearch = false;
                                    timer && clearTimeout(timer);
                                    // 获取第一个智能搜索的结果
                                    let poi = local.getResults().getPoi(0);
                                    isError = true;
                                    success(poi);
                                },
                                pageCapacity: 5,
                            });
                            local.search(addressName);
                        }

                        // 设置控件
                        map.enableScrollWheelZoom(); // 启用滚轮放大缩小，默认禁用
                        map.enableContinuousZoom(); // 启用地图惯性拖拽，默认禁用
                        setTimeout(function () {
                            $('.anchorBL').remove();
                        }, 1000);
                        map.addControl(new BMap.NavigationControl({
                            anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
                            offset: new BMap.Size(320, 0)
                        })); // 添加默认缩放平移控件

                        setTimeout(function () {
                            fixSeggestLocation();
                        }, 3000);

                        /**
                         * [watchSearchInput 搜索框地址发生变化时调整下拉列表样式]
                         *
                         * @return  {[type]}  [return description]
                         */
                        function fixSeggestLocation() {
                            if (scope.mediaFlag && scope.mediaFlag === 'douyin') {
                                $('.tangram-suggestion-main').addClass('tangram-suggestion-main-for-douyin');
                            } else {
                                $('.tangram-suggestion-main').addClass('tangram-suggestion-main-for-weibo');
                            }
                        }

                        // 完成选择
                        scope.finish = function () {
                            let sinaAddress = scope.data.sinaAddressList[scope.status.curSelectIndex];
                            let result;
                            if (scope.mediaFlag && scope.mediaFlag === 'douyin') {
                                scope.defaultPlace.placeName = sinaAddress.TITLE;
                                scope.defaultPlace.lng = sinaAddress.LNG;
                                scope.defaultPlace.lat = sinaAddress.LAT;
                                scope.defaultPlace.city = sinaAddress.CITY_NAME;
                                scope.defaultPlace.title = sinaAddress.TITLE;
                                result = {
                                    POI_NAME: sinaAddress.POI_NAME,
                                    POI_ID: sinaAddress.POI_ID
                                };
                            } else {
                                if (isSpecialCity(sinaAddress)) {
                                    sinaAddress.CITY_NAME = getSpecialCity(sinaAddress);
                                }
                                result = sinaAddress.CITY_NAME + '·' + sinaAddress.TITLE;
                                scope.defaultPlace.placeName = result;
                                scope.defaultPlace.lng = sinaAddress.LNG;
                                scope.defaultPlace.lat = sinaAddress.LAT;
                            }
                            scope.confirm()(result);
                        };

                        /**
                         * [isSpecialCity 是否为直辖市或特别行政区]
                         *
                         * @param   {[type]}  address  [address description]
                         *
                         * @return  {[type]}           [return description]
                         */
                        function isSpecialCity(address) {
                            return '重庆市, 北京市, 天津市, 香港特别行政区, 澳门特别行政区, 台湾省'.indexOf(address.PROVINCE) !== -1;
                        }

                        /**
                     * [getSpecialCity 获取直辖市或特别行政区城市名]
                     *
                     * @param   {[type]}  address  [address description]
                     *
                     * @return  {[type]}           [return description]
                     */
                        function getSpecialCity(address) {
                            return [].slice.call(address.PROVINCE, 0, 2).join('');
                        }

                        /**
                     * [loadSinaAddress 加载新浪地址库]
                     *
                     * @param   {[type]}  point  [point description]
                     * @param   {[type]}  isRelocation  [是否二次定位]
                     *
                     * @return  {[type]}         [return description]
                     */
                        function loadSinaAddress(point, isRelocation) {
                            scope.hideSinaList();
                            scope.data.sinaAddressList = [];
                            scope.status.curSelectIndex = 0;
                            scope.data.params.jd = point.lng;
                            scope.data.params.wd = point.lat;
                            scope.loadingPromise = trsBaiduMapService.getSinaAddressList(scope.data.params).then(function (data) {
                                if (data.CODE === '200') {
                                    scope.data.sinaAddressList = data.DATAS;
                                    if (isRelocation) {
                                        scope.data.sinaAddressList.forEach(function (item, index) {
                                            let sinaAddress = item.CITY_NAME + '·' + item.TITLE;
                                            if (sinaAddress === scope.defaultPlace.placeName) {
                                                scope.status.curSelectIndex = index;
                                            }
                                        });
                                    } else {
                                        scope.data.sinaAddressList.forEach(function (item, index) {
                                            let sinaAddress = item.TITLE;
                                            if (scope.address && filterPlaceName(scope.address).indexOf(filterPlaceName(sinaAddress)) !== -1) {
                                                scope.status.curSelectIndex = index;
                                            }
                                        });
                                    }
                                } else {
                                    modalDialog.alertType('error', '错误', data.message);
                                }
                            }, function (data) {

                            });
                        }

                        /**
                     * [loadGaodeAddress 获取高德POI地址]
                     *
                     * @param   {[type]}  city     [city description]
                     * @param   {[type]}  keyword  [keyword description]
                     * @param   {[type]}  isRelocation  [是否二次定位]
                     *
                     * @return  {[type]}           [return description]
                     */
                        function loadGaodeAddress(city, keyword, isRelocation) {
                            scope.hideSinaList();
                            scope.data.sinaAddressList = [];
                            scope.status.curSelectIndex = 0;
                            scope.data.params.city = city;
                            scope.data.params.keyword = keyword;
                            scope.loadingPromise = trsBaiduMapService.getGaodeAddressList(scope.data.params).then(function (data) {
                                if (data.CODE === '200') {
                                    scope.data.sinaAddressList = data.DATAS;
                                    if (isRelocation) {
                                        scope.data.sinaAddressList.forEach(function (item, index) {
                                            let sinaAddress = item.POI_NAME;
                                            if (sinaAddress === scope.defaultPlace.placeName) {
                                                scope.status.curSelectIndex = index;
                                            }
                                        });
                                    } else {
                                        scope.data.sinaAddressList.forEach(function (item, index) {
                                            let sinaAddress = item.POI_NAME;
                                            let keywords = scope.address || keyword;
                                            if (filterPlaceName(keywords).indexOf(filterPlaceName(sinaAddress)) !== -1) {
                                                scope.status.curSelectIndex = index;
                                            }
                                        });
                                    }
                                } else {
                                    modalDialog.alertType('error', '错误', data.message);
                                }
                            }, function (data) {

                            });
                        }

                        /**
                     * [filterPlaceName 过滤地点中的特殊字符]
                     *
                     * @param   {[type]}  placeName  [placeName description]
                     *
                     * @return  {[type]}             [return description]
                     */
                        function filterPlaceName(placeName) {
                            return placeName.replace('(', '').replace(')', '').replace('-', '');
                        }

                        // 取消插入地图
                        scope.close = function () {
                            scope.hideSinaList();
                            scope.data.sinaAddressList = [];
                            scope.status.curSelectIndex = '';
                            scope.cancel()();
                        };

                        /**
                     * [switchCheck 选中新浪地址]
                     *
                     * @param   {[type]}  index  [index description]
                     *
                     * @return  {[type]}         [return description]
                     */
                        scope.switchCheck = function (index) {
                            if (scope.status.curSelectIndex === index) {
                                return;
                            }
                            scope.status.curSelectIndex = index;
                            let curentPlace = scope.data.sinaAddressList[index];
                            getPoiByAddressName(curentPlace.CITY_NAME + curentPlace.TITLE, function (poi) {
                                let pp = poi.point;
                                map.centerAndZoom(pp, defaultZoomLevel);
                                trsBaiduMapService.setMarker(map, pp);
                                map.panTo(pp);
                            });

                        };

                        /**
                     * [hideSinaList 关闭新浪地址库列表]
                     *
                     * @return  {[type]}  [return description]
                     */
                        scope.hideSinaList = function () {
                            // scope.status.isShowSinaAddressList = false;
                        };
                        //  在此处便可实例化BMap
                        //  注意在上面不可写成function(BMap),否则会提示 BMap is undefined
                    });


                    // scope.$watch('address', function () {
                    //     if (scope.status.isShowSinaAddressList) {
                    //         scope.hideSinaList();
                    //     }
                    // });
                },
            };
        },
    ]);
